<template>
  <div class="modal fade" tabindex="-1" :id="modalId">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Histórico de envio</h5>
          <button type="button" class="btn btn-icon btn-sm btn-active-light-primary" data-bs-dismiss="modal" aria-label="Fechar">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="loading" class="text-center py-5">
            <span class="spinner-border text-primary"></span>
          </div>
          <div v-else-if="messages.length < 1" class="text-center text-muted py-5">
            Nenhuma mensagem encontrada.
          </div>
          <div v-else class="table-responsive">
            <table class="table table-row-bordered gy-4">
              <thead>
              <tr class="text-center fw-bold text-muted">
                <th>Data</th>
                <th>Canal</th>
                <th>Destino</th>
                <th>Status atual</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <template v-for="message in messages" :key="message.id_puim">
                <tr class="text-center">
                  <td>{{ formatDate(message.puim_sent_at) }}</td>
                  <td>{{ message.channel_label }}</td>
                  <td>{{ formatDestination(message) }}</td>
                  <td>
                    <span class="badge badge-light-primary">{{ message.latest_status_label || 'Enviado' }}</span>
                  </td>
                  <td>
                    <button v-if="(message.statuses?.length ?? 0) > 0"
                            class="btn btn-sm btn-light"
                            type="button"
                            data-bs-toggle="collapse"
                            :data-bs-target="'#invite-message-status-' + message.id_puim">
                      Detalhes
                    </button>
                  </td>
                </tr>
                <tr>
                  <td colspan="5" class="p-0">
                    <div class="collapse" :id="'invite-message-status-' + message.id_puim">
                      <table class="table table-bordered mb-0">
                        <thead>
                        <tr>
                          <th>Data/Hora</th>
                          <th>Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="status in message.statuses" :key="status.id_status">
                          <td>{{ formatDate(status.received_at) }}</td>
                          <td>{{ status.status_dsc }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../helpers/http";
import strMask from "../../helpers/strMask";

export default {
  name: "PlaceUserInviteMessageModal",
  props: {
    modalId: {
      type: String,
      default: 'modal_invite_messages',
    },
    placeId: {
      type: [Number, String],
      required: true,
    },
    inviteId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      messages: [],
    };
  },
  methods: {
    formatDate(value) {
      if (!value) {
        return '-';
      }

      return moment(value).format('DD/MM/YYYY HH:mm');
    },
    formatDestination(message) {
      if (message.puim_channel === 'whatsapp') {
        return strMask.it(message.puim_destination, '(##) #####-####');
      }

      return message.puim_destination;
    },
    open(inviteId) {
      this.loading = true;
      this.messages = [];

      http.get(`/places/${this.placeId}/users/invites/${inviteId}/messages`).then((response) => {
        this.messages = response.data;
      }).finally(() => {
        this.loading = false;
        bootstrap.Modal.getOrCreateInstance(document.getElementById(this.modalId)).show();
      });
    },
  },
};
</script>
